import type { PropType } from 'vue';
import type { User } from '@devhacker/shared/features/user/types/user';
import AdminControlsPanel from '@/components/lh-ui/AdminControlsPanel/AdminControlsPanel.vue';
import AppPicture from '@/components/lh-ui/AppPicture/AppPicture.vue';

import { getPrepTimeFormattedSimplified } from '~/utils';

import ArticleCardActions from '~/components/ArticleCardActions/ArticleCardActions.vue';
import ReactionButton from '~/components/ReactionButton/ReactionButton.vue';
import AuthorsExperts from '~/components/AuthorsExperts/AuthorsExperts.vue';
import { removeLifehackerFromUrl } from '~/utils/removeLifehackerFromUrl';

export default defineNuxtComponent({
  name: 'RecipeCard',

  components: {
    ArticleCardActions,
    AdminControlsPanel,
    ReactionButton,
    AuthorsExperts,
    AppPicture,
  },

  inject: {
    eventName: {
      default() {
        return () => '';
      },
    },
  },

  props: {
    eventPosition: {
      type: String as PropType<string>,
      default: 'recipe-top',
    },
    title: {
      type: String as PropType<string>,
      required: true,
    },
    author: {
      type: Object as PropType<FullRecipe['author']>,
      default: null,
    },
    expert: {
      type: Object as PropType<FullRecipe['expert']>,
      default: null,
    },
    cookingTime: {
      type: Number as PropType<number>,
      required: true,
    },
    // показывать время приготовления
    isCookingTimeVisible: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String as PropType<string>,
      required: true,
    },
    covers: {
      type: Object as PropType<TImage>,
      required: true,
    },
    likes: {
      type: Number as PropType<number>,
      required: true,
    },
    dislikes: {
      type: Number as PropType<number>,
      required: true,
    },
    user: {
      type: Object as PropType<User | null>,
      default: null,
    },
    favorite: {
      type: Object as PropType<IFavoriteItem | null>,
      default: null,
    },
    folders: {
      type: Object as PropType<IFolders>,
      required: true,
    },
    showAdminControlsPanel: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    viewsCount: {
      type: Number as PropType<number>,
      required: true,
    },
    linkToEdit: {
      type: String as PropType<string>,
      required: true,
    },
    viewsLoading: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    reactionState: {
      type: String as PropType<null | 'like' | 'dislike'>,
      default: null,
    },
    commentsEnabled: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    commentsCount: {
      type: Number as PropType<number>,
      required: true,
    },
    scrollToComments: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    linkEnabled: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    titleTagName: {
      type: String as PropType<string>,
      default: 'p',
    },
    coverLoading: {
      type: String as PropType<'eager' | 'lazy' | 'auto'>,
      default: 'lazy',
    },
    addAnalyticsAttribute: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    openCommentsInNewTab: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  data() {
    return { isLocalhost: false };
  },

  mounted() {
    this.isLocalhost = location.hostname === 'localhost';
  },

  methods: {
    getPrepTimeFormattedSimplified,
    removeLifehackerFromUrl,

    sendReactionAnalytics(type: 'update-like' | 'update-dislike', isActive: boolean) {
      this.$emit(type);
      this.$sendYandexMetrika({
        level1: 'Клик_Реакции',
        level4: '',
        level5: isActive ? 'Убрали реакцию' : 'Поставили реакцию',
        level6: type.replace('update-', ''),
      });
    },
    onFavoriteDeferredEmit(deferredAction: Function, ctx: any) {
      this.$emit('favorite-deferred', deferredAction, ctx);
    },
    onFavoriteAddToFolderEmit(folder: IFolderItem) {
      this.$emit('favorite-add-to-folder', folder);
    },
    onFavoriteTransferToFolderEmit(favorite: IFavoriteItem, folder: IFolderItem) {
      this.$emit('favorite-transfer-to-folder', favorite, folder);
    },
    onFavoriteCreateFolderAndTransferEmit(nameFolder: string, favorite: IFavoriteItem): void {
      this.$emit('favorite-create-folder-and-transfer', nameFolder, favorite);
    },
    onFavoriteCreateFolderAndAddEmit(nameFolder: string): void {
      this.$emit('favorite-create-folder-and-add', nameFolder);
    },
    onFavoriteDeleteEmit(favorite: IFavoriteItem): void {
      this.$emit('favorite-delete', favorite);
    },
    onClickTitle() {
      this.$emit('click-title');
    },
    clickPicture() {
      this.$emit('click-picture');
    },
  },
});
